/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import topluStokKartTanimlari from "./TopluStokKartTanimlari/topluStokKartTanimlari";
import signalRStore from "./signalR/signalRStore";
import musteriYonetimiStore from "./MusteriYonetimi/musteriYonetimiStore";
import temsilciDegerlendirmeStore from "./TemsilciDegerlendirme/temsilciDegerlendirmeStore";
import horizontalNavStore from "./HorizontalNav/horizontalNavStore";
import kullaniciTakipStore from "./D7KKullaniciTaklipSistemi/kullaniciTakipStore";
import sikayetVeOneriStore from "./B2bSikayetVeOneri/sikayetVeOneriStore";
import scadaBildirimStore from "./ScadaBildirim/scadaBildirimStore";
import checkPlatformStore from "./CheckPlatform/checkPlatformStore";
import platformSettingsStore from "./PlatformSettings/platformSettingsStore";
import b2bCustomerSupportStore from "./B2bStore/CustomerSupport/customerSupportStore";
import b2bRatingStore from "./B2bStore/rating/ratingStore";
import b2bSignalRStore from "./B2bStore/signalR/b2bSignalRStore";
import teklifToplamaStore from "./TeklifToplama/teklifToplamaStore";
import d7kWorkListStore from "./D7KisListesi/d7kWorkListStore";
import fileUploadStore from "./FileUploadStore/fileUploadStore";
import scadaRaporStore from "./ScadaRapor/scadaRaporStore";

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    topluStokKartTanimlari,
    signalRStore,
    musteriYonetimiStore,
    temsilciDegerlendirmeStore,
    horizontalNavStore,
    kullaniciTakipStore,
    sikayetVeOneriStore,
    scadaBildirimStore,
    checkPlatformStore,
    platformSettingsStore,
    b2bCustomerSupportStore,
    b2bRatingStore,
    b2bSignalRStore,
    teklifToplamaStore,
    d7kWorkListStore,
    fileUploadStore,
    scadaRaporStore,
  },
  strict: process.env.NODE_ENV !== "production",
});
